import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class ImportResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/imports' as const;

  readonly counter: number | undefined = undefined;
  readonly errors: Record<string, unknown>[] = [];


  pk() {
    return 'import';
  }
}
